export const expertBuyOrderCn = {
    qxzfw:"请选择服务"
}


// WEBPACK FOOTER //
// ./src/lang/home/expertBuyOrder/indexCn.js